import { Triangle, Hexagon, Circle, Square, Diamond, Pentagon } from "lucide-react";

const LOGOS = [
    { icon: Triangle, name: "RelayStack" },
    { icon: Hexagon, name: "Forgebase" },
    { icon: Circle, name: "Quantleaf" },
    { icon: Square, name: "Northwind AI" },
    { icon: Diamond, name: "Helios Labs" },
    { icon: Pentagon, name: "Driftworks" },
];

const LogoStrip = () => (
    <section data-testid="logo-strip" className="border-t border-[#262626]">
        <div className="mx-auto max-w-6xl px-4 py-12 sm:px-6">
            <p className="text-center font-mono text-[10px] uppercase tracking-[0.4em] text-neutral-600">
                Powering agent memory at
            </p>
            <div className="mt-8 grid grid-cols-2 items-center gap-6 sm:grid-cols-3 lg:grid-cols-6">
                {LOGOS.map((logo, i) => (
                    <div
                        key={logo.name}
                        data-testid={`customer-logo-${i}`}
                        className="group flex items-center justify-center gap-2 opacity-50 transition-opacity duration-200 hover:opacity-100"
                    >
                        <logo.icon className="h-4 w-4 text-neutral-400 transition-colors group-hover:text-green-400" />
                        <span className="font-mono text-sm font-medium tracking-tight text-neutral-300">
                            {logo.name}
                        </span>
                    </div>
                ))}
            </div>
        </div>
    </section>
);

export default LogoStrip;
